import { withNamespace } from "@/i18n/lazy-route"

/** Prices and the plan editor (LLD §9.22, Task 6.5), with the `adminPrices` namespace. */
const translations = {
  en: () => import("@/i18n/locales/en/adminPrices.json"),
  fr: () => import("@/i18n/locales/fr/adminPrices.json"),
}

export const PricesScreen = withNamespace(
  "adminPrices",
  () => import("./screens/PricesScreen"),
  translations,
)
export const PlansScreen = withNamespace(
  "adminPrices",
  () => import("./screens/PlansScreen"),
  translations,
)
